import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import CustomTabs from '../../components/CustomTabs';
import CustomToggle from '../../components/CustomToggle';
import Header from '../../components/Header';
import EntitiesSettingsRow from '../../components/tables/admin/internal/EntitiesSettingsRow';
import JobsSettingsRow from '../../components/tables/admin/internal/JobsSettingsRow';
import SitesSettingsRow from '../../components/tables/admin/internal/SitesSettingsRow';
import UsersSettingsRow from '../../components/tables/admin/internal/UsersSettingsRow';
import { useAuth } from '../../hooks/useAuth';
import { capitalizeFirstLetter } from '../../utils/capitalize';
import { localStorageKeys, permissionLevels } from '../../utils/enums';
import { getItemFromLocalStorage, storeItemToLocalStorage } from '../../utils/localStorage';
import { usePageTitle } from '../../hooks/usePageTitle';
import ToggleLine from '../../components/ToggleLine';
import LoadNaturesSettingsRow from '../../components/tables/admin/internal/LoadNaturesSettingsRow';

const InternalAdminPage: React.FC = () => {
    const [selectedTab, setSelectedTab] = useState(parseInt(getItemFromLocalStorage(localStorageKeys.TAB.ADMININTERNAL) || '0'));
    const [withUsageCount, setWithUsageCount] = useState<boolean>(false);

    const { t } = useTranslation();
    const { user } = useAuth();
    usePageTitle(capitalizeFirstLetter(t('internal')));

    const handleTabChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        setSelectedTab(newValue);
        storeItemToLocalStorage(localStorageKeys.TAB.ADMININTERNAL, newValue.toString());
    };

    return (
        <div className="fx-c h-100">
            <Header
                title={t('admin')}
                breadcrumbs={[{ label: capitalizeFirstLetter(t('internal')) }]}
                subTitle={capitalizeFirstLetter(t('internal'))}
                isDateVisible={false}
            >
                {user?.profileId.permsLevel === permissionLevels.ADMIN && (
                    <ToggleLine title={capitalizeFirstLetter(t('showUsage'))} checked={withUsageCount} onChange={setWithUsageCount} />
                )}
            </Header>
            <CustomTabs
                selectedTab={selectedTab}
                handleTabChange={handleTabChange}
                tabLabels={[t('users'), t('jobs'), t('sites'), t('entities'), t('loadNatures')]}
            />
            {selectedTab == 0 && <UsersSettingsRow withUsageCount={withUsageCount} />}
            {selectedTab == 1 && <JobsSettingsRow withUsageCount={withUsageCount} />}
            {selectedTab == 2 && <SitesSettingsRow withUsageCount={withUsageCount} />}
            {selectedTab == 3 && <EntitiesSettingsRow withUsageCount={withUsageCount} />}
            {selectedTab == 4 && <LoadNaturesSettingsRow withUsageCount={withUsageCount} />}
        </div>
    );
};

export default InternalAdminPage;
